import { getAttribute, type ScriptParams } from '../getScriptParams.tsx';
import type { PluginTypeButtonParams } from './PluginTypeParams.ts';

type GetPluginTypeButtonParamsArgs = {
  node: Element;
  projectType: string;
  scriptParams?: Partial<ScriptParams>;
};

export const getPluginTypeButtonParams = ({
  node,
  projectType,
  scriptParams,
}: GetPluginTypeButtonParamsArgs): PluginTypeButtonParams => {
  const appID = getAttribute(node, 'data-appid') || scriptParams?.appID;
  const value = getAttribute(node, 'data-value') || undefined;

  const customerData =
    getAttribute(node, 'data-customer-fields') || scriptParams?.customerData;

  const additionalInfo =
    getAttribute(node, 'data-additional-info') || undefined;

  const variant =
    getAttribute(node, 'data-variant') || scriptParams?.buttonVariant;

  const correlationID = getAttribute(node, 'data-correlationID') || undefined;

  const isTemp = !!scriptParams?.isTemp;

  return {
    appID,
    value,
    customerData,
    additionalInfo,
    variant,
    correlationID,
    projectType,
    isTemp,
  };
};
